module.exports = __webpack_public_path__ + "static/media/maintenance.010cd056.png";